<h3 mat-dialog-title>{{ isAdding ? 'Add reward product' : 'Edit reward product' }}</h3>


<div class="avatar-container" (click)="fileInputAvatar.click()">
  <input id="uploadAvatarInput" #fileInputAvatar type="file" accept=".png, .jpg, .jpeg" (change)="onAvatarImageSelected($event)">
  <div class="icon-container">
    <mat-icon color="primary">photo_camera</mat-icon>
  </div>
  <div class="avatar">
    <lib-photo [url]="photoUrl" [width]="'153px'" [height]="'153px'" [radius]="'10px'"></lib-photo>
  </div>
</div>


<form (ngSubmit)="onSubmit()" [formGroup]="form" class="vertical-form">

  <div mat-dialog-content class="content">

    <mat-form-field>
      <mat-label>Reward product title</mat-label>
      <input type="text" required matInput placeholder="" formControlName="title" maxlength="50" autocomplete="off">
      @if (!form.get('title').valid) {
        <mat-error>Please enter a valid reward title</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Reward description</mat-label>
      <textarea rows="6" matInput placeholder="" formControlName="description" maxlength="1000" autocomplete="off"></textarea>
      @if (!form.get('description').valid) {
        <mat-error>Please enter a valid reward description (max 1000 characters)</mat-error>
      }
    </mat-form-field>

  </div>

  <div mat-dialog-actions class="gap-8">
    <lib-button variant="stroked" mat-dialog-close>Close</lib-button>
    <lib-button type="submit" variant="raised" [disabled]="!form.valid || !photoUrl">Save</lib-button>
  </div>

</form>

<lib-loading-overlay [isLoading]="isLoading" />
